export default __webpack_public_path__ + "static/media/UnChecked_icon.58050943.svg";